<template>
  <div class="d-flex align-items-center">
    <div v-if="pageCached">
      <div :title="translations.page_creation_date_explanation" class="text-xs mr-3 text-right">
        <div class="text-uppercase text-gray-500 font-weight-bold">
          {{ translations.page_creation_date }}
        </div>
        <div class="text-white privacy">{{ pageCreationDate }}</div>
      </div>
    </div>
    <div class="text-xs mr-3 text-right">
      <div class="text-uppercase text-gray-500 font-weight-bold">{{ translations.logged_in }}</div>
      <div class="text-white privacy">{{ currentUser.email }}</div>
    </div>
    <a :href="adminPath" class="btn btn-icon btn-sm btn-gray-700">
      <span class="icon i-lg icon-settings"></span>
      <span class="d-none d-sm-block ml-1">
        {{ translations.admin_area }}
      </span>
    </a>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ManagementBar",
  props: {
    translations: {
      type: Object,
      required: true,
    },
    adminPath: {
      type: String,
      required: true,
    },
    pageCached: {
      type: Boolean,
      required: false,
      default: false,
    },
    pageCreationDate: {
      type: String,
      required: false,
      default: "",
    },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser/currentUser",
    }),
  },
  mounted() {
    this.fetchCurrentUser();
  },
  methods: {
    ...mapActions({ fetchCurrentUser: "currentUser/fetchCurrentUser" }),
  },
};
</script>
